




















import Vue from 'vue'
import NavView from './navs/nav-view.vue'
import NavTag from './navs/nav-tag.vue'
import NavDatasource from './navs/nav-datasource.vue'
import NavHistoricalData from './navs/nav-historical-data.vue'
import NavSynchronizer from './navs/nav-synchronizer.vue'
import NavDataPublisher from './navs/nav-data-publisher.vue'
import NavAlarm from './navs/nav-alarm.vue'
import NavLogical from './navs/nav-logical.vue'
import NavTask from './navs/nav-task.vue'
import NavUserManagement from './navs/nav-user-management.vue'
export default Vue.extend({
  components: {
    NavView,
    NavTag,
    NavDatasource,
    NavHistoricalData,
    NavSynchronizer,
    NavDataPublisher,
    NavAlarm,
    NavLogical,
    NavTask,
    NavUserManagement,
  },
})
